import { createContext } from 'react';

export const NavigationContext = createContext<{
  navigateToDataHub: (index: number) => void;
}>({
  navigateToDataHub: () => {}
});
